<template>
  <vs-popup class="customer-bespoke-price-add-popup"
            title="ADD CUSTOMER BESPOKE PRICE"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                v-model="filters['search']"
                class="is-label-placeholder px-0 pb-5
                 w-full md:w-full xl:w-full rounded-full"/>
      <vs-table noDataText="Type to search products" :max-items="(meta.per_page) ? meta.per_page : 10"
                :hoverFlat="true" :sst="true" id="create-bespoke-price-table" :data="productList">


        <template slot="thead">
          <vs-th>ITS PRODUCT CODE</vs-th>
          <vs-th>ITS PRODUCT NAME</vs-th>
          <vs-th>CUSTOMER PRODUCT NAME</vs-th>
<!--          <vs-th>LIST PRICE ({{ account_currency }})</vs-th>-->
          <vs-th width="25%">ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="tr.warnings.length > 0 ? 'danger' : tr.errors.length > 0 ? 'warning' : null" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].formulation_code">
              {{ data[indextr].formulation_code }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td>
              {{ data[indextr].customer_product_code || '' }}
            </vs-td>

<!--            <vs-td :data="data[indextr].list_price">-->
<!--              {{ data[indextr].list_price }}-->
<!--            </vs-td>-->

            <vs-td>
              <div class="vx-row">
                <vs-button :id="'add_button'+''+ indextr" v-if="data[indextr].warnings.length === 0"
                          @click.native="onClickAdd(data[indextr], indextr)"
                          size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus" class="mr-2">Add
                </vs-button>
                <vx-tooltip v-if="data[indextr].errors.length > 0" text="View Missing Elements" position="top" class="mr-2">
                          <vs-button @click.stop="onClickViewErrors(data[indextr].errors)"
                                    size="small" color="warning" type="border" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
                </vx-tooltip>
                <vx-tooltip v-if="data[indextr].warnings.length > 0" text="Contract pricing has been setup for this item. Please delete that before adding here." position="top" class="mr-2">
                          <vs-button @click.stop="null"
                                    size="small" color="danger" type="border" icon-pack="feather" icon="icon-alert-circle"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>

          </vs-tr>
        </template>

      </vs-table>
      <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

    </vx-card>
    <customer-bepoke-price-tiers-pop-up
      v-on:refreshData="fetchCustomerProductLIst"
      v-bind:account_currency="account_currency"
      ref="customerBepokePriceTiersPopUp"
    />
    <rm-catalogue-error-pop-up ref="rmCatalogueErrorPopUp"/>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer')
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
const IncotermRepository = RepositoryFactory.get('incoterm');
import Filter from '@/mixins/filter';

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import CustomerBepokePriceTiersPopUp from "@/components/popups/customer/bespoke-price/CustomerBepokePriceTiersPopUp";
import RmCatalogueErrorPopUp from "@/components/popups/inventory/rm-orders/RmCatalogueErrorPopUp";

function initialState() {
  return {
    open: false,
    id: '',
    incoterms: [],
    createForm: {
      address: {}
    },
    page : 1,
    total: 0,
    meta : {},
    filters: {},
    countryCodes: [],
    customerUsers: [],
    isCreateFromMainMenu: false,
    productList: []
  }
}

export default {
  name: 'CreateCustomerBespokePricePopUp',
  data() {
    return initialState()
  },
  props: {
    account_currency: {type: String, default: ''}
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.id = id
        // await this.fetchCustomerProductLIst()
      } catch (error) {

      }
    },
    async fetchCustomerProductLIst() {
      await this.$vs.loading({
        container: `#create-bespoke-price-table`,
        scale: 0.45
      })
      const {data} = await CustomerRepository.getCustomerProductList(this.id, this.page, this.filterQuery, 10)
      this.productList = data.data
      this.meta = data.meta
      this.$vs.loading.close(`#create-bespoke-price-table > .con-vs-loading`)
    },
    async onClickAdd(data) {
      const payload = {
        customer_id: this.id,
        formulation_id: data.id,
        incoterm: '',
        tiers: [],
        note: '',
      }
      await this.$refs.customerBepokePriceTiersPopUp.openPopup(payload, data)
    },
    onClickViewErrors(errors) {
      this.$refs.rmCatalogueErrorPopUp.openPopUp(errors, 'PRODUCT')
    },
    filterQueryUpdate() {
      this.page = 1
      if(this.filters.search) {
        this.fetchCustomerProductLIst()
      } else {
        this.productList = []
      }
    },
    async onClickClose() {
      await this.$parent.refreshData()
      this.open = false
    }
  },
  async mounted() {

  },
  components: {
    'v-select': vSelect,
    CustomerBepokePriceTiersPopUp,
    RmCatalogueErrorPopUp,
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
  watch : {
      page(){
        this.fetchCustomerProductLIst()
      }
    }
}
</script>

<style scoped>
.customer-bespoke-price-add-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 60% !important;
}

</style>
